import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/login/login.service';
import { StorageKeys } from "../../util/constants";
import { Router } from '@angular/router';
import { ROUTE_CONSTANTS } from '../../util/route.constants';
import { environment } from '../../../environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Authorize } from '@privatelib/ngx18-authz-dev';
import { Facility, FetchFacilityResponse } from '../../models/facility.interface';

@Component({
    standalone: false,
    selector: 'cva-facility-selection',
    templateUrl: './facility-selection.component.html',
    
})
export class FacilitySelectionComponent implements OnInit {
  availableFacilities: Facility[] = [];
  cvaUI_url = environment.cvaUI_url;
  facilitySelectionForm: FormGroup = new FormGroup({
    activeFacility: new FormControl('', [Validators.required])
  });
  processing = true;
  redirectTo: string = '';

  constructor(
    private readonly loginService: LoginService,
    private readonly router: Router,
    private readonly auth: Authorize
  ) { }

  ngOnInit(): void {
    this.processing = true;
    this.redirectTo = localStorage.getItem('redirectTo') ?? '';
    if (localStorage.getItem(StorageKeys.FACILITY_CODE)) {
      this.setSelectedFacility();
      this.router.navigate([this.redirectTo || ROUTE_CONSTANTS.PATIENT_DASHBOARD]);
      return;
    }
    const userId = this.auth.getUserDetails()?.id;
    if (userId) {
      this.loginService.getMappedFacilities(userId).subscribe({
        next: (response: FetchFacilityResponse) => {
          const facilities = response.data;
          this.availableFacilities = facilities;
          if (this.availableFacilities.length === 1) {
            localStorage.setItem(StorageKeys.FACILITY_CODE, this.availableFacilities[0].id);
            localStorage.setItem(StorageKeys.FACILITY_NAME, this.availableFacilities[0].name);
            this.setSelectedFacility();
            this.router.navigate([this.redirectTo || ROUTE_CONSTANTS.PATIENT_DASHBOARD]);
          } else {
            this.activeFacility?.setValue(this.availableFacilities[0]);
            this.processing = false;
          }
        }
      })
    }
  }

  get activeFacility() {
    return this.facilitySelectionForm.get('activeFacility');
  }

  selectFacilityId() {
    if (this.activeFacility?.value) {
      localStorage.setItem(StorageKeys.FACILITY_CODE, this.activeFacility?.value.id);
      localStorage.setItem(StorageKeys.FACILITY_NAME, this.activeFacility?.value.name);
      this.setSelectedFacility();
      this.router.navigate([this.redirectTo || ROUTE_CONSTANTS.PATIENT_DASHBOARD]);
    }
  }

  setSelectedFacility() {
    this.loginService.selectedFacility.next((localStorage.getItem(StorageKeys.FACILITY_CODE) ?? '') + ' - ' + (localStorage.getItem(StorageKeys.FACILITY_NAME) ?? ''));
  }
}
